// Import and configure the Stimulus library
import { Application } from "@hotwired/stimulus"

// Start the Stimulus application
const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus = application

// Import all controller files and register them
const context = require.context(".", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

// Helper function to load controller definitions from context
function definitionsFromContext(context) {
  return context.keys().map((key) => {
    const controllerName = key
      .replace("./", "")
      .replace(/_controller\.js$/, "")
      .replace(/\//g, "--")
      .replace(/_/g, "-")
    
    return {
      identifier: controllerName,
      controllerConstructor: context(key).default
    }
  })
} 